<template>
	<div v-loading="loading" class="min_cw padding_xl_lr">
		<HomeTitleItem title="业务介绍" sub="BUSINESS INTRODUCTION" />

		<ul class="home_work_list">
			<li v-for="(item, index) in list" :key="index" @click="handleClick(item, index)">
				<div class="img_box">
					<div class="hexagon"></div>
					<div class="hexagon_bg"></div>

					<img class="img" :src="require('@/assets/' + item.work_icon + '.png')" alt="">
				</div>
				<p class="title">{{ $getDictLabel(typeList, item.work_type) }}</p>
			</li>
		</ul>
	</div>
</template>

<script>
import HomeTitleItem from './titleItem'
import {getDictDataApi, getWorkInfoListApi} from "@/api";

export default {
	name: "index",
	components: {
		HomeTitleItem,
	},
	data() {
		return {
			loading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 5,
				orderContent: "order_info asc",
			},
			list: [],
			typeList: [],
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			this.loading = true;
			await this.initDict();
			this.getList();
		},

		async getList() {
			this.loading = true;
			const res = await getWorkInfoListApi(this.queryParams);
			this.list = res.rows;
			this.loading = false;
		},

		/**
		 * 获取字典中的业务类型
		 */
		async initDict() {
			const res = await getDictDataApi("work_type");
			this.typeList = res.data;
		},

		handleClick(item, index) {
			this.$router.push("/work?id=" + item.work_id);
		}
	}
}
</script>

<style lang="less" scoped>
.home_work_list {
	transition: all 1s;
	transform: translateX(0);

	width: 100%;
	display: flex;
	justify-content: center;

	>li {
		flex-shrink: 0;
		width: calc(20% - 15px);
		margin: 0 15px;
		cursor: pointer;
	}

	>li:first-of-type {
		margin-left: 0;
	}
	>li:last-of-type {
		margin-right: 0;
	}

	.img_box {
		width: 120px;
		height: 120px;
		position: relative;
		overflow: hidden;
		transition: all .3s;
		margin: 0 auto;

		.img {
			width: 50%;
			height: 50%;
			object-fit: cover;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	.title {
		font-size: 16px;
		color: @black;
		text-align: center;
		.ellipsis;
		margin-top: 15px;
	}
}

.hexagon {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url("~@/assets/hexagon1.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
}

.hexagon_bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url("~@/assets/hexagon2.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
}

.img_box:hover {
	.hexagon {
		animation: turn1 6s 1 linear;
	}

	.hexagon_bg {
		animation: turn2 6s 1 linear;
	}
}

@keyframes turn1 {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(-360deg);
	}
}

@keyframes turn2 {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
